import { datadogRum } from "@datadog/browser-rum";
import { reactPlugin } from "@datadog/browser-rum-react";

const isDatadogEnabled = process.env.NODE_ENV === "production";

export const initDatadogRum = () => {
  if (!isDatadogEnabled) return;

  datadogRum.init({
    applicationId: process.env.REACT_APP_DATADOG_APPLICATION_ID || "",
    clientToken: process.env.REACT_APP_DATADOG_CLIENT_TOKEN || "",
    site: "datadoghq.com",
    service: "wm-react",
    env: "production",
    version: process.env.VERSION || "unknown",
    sessionSampleRate: 100,
    sessionReplaySampleRate: 20,
    defaultPrivacyLevel: "mask-user-input",
    plugins: [reactPlugin({ router: true })],
  });
};

export const setDatadogRumUser = (user: { id: string; name: string; email: string }) => {
  if (!isDatadogEnabled) return;

  datadogRum.setUser({
    id: user.id,
    name: user.name,
    email: user.email,
  });
};
